export default "__VITE_ASSET__b397edc2__"